import React, { useCallback } from "react";
import ReactGA from "react-ga";
import { useDropzone } from "react-dropzone";
import Provider from "core/provider/";
import Config from "config"; // 프로그램 환경설정 모듈
import "./dropzone.styl";

// function downloadExampleData(targetlink) {
//   console.log("targetlink: ", targetlink);
//   fetch(targetlink).then((response) => {
//     response.blob().then((blob) => {
//       let url = window.URL.createObjectURL(blob);
//       let a = document.createElement("a");
//       a.href = url;
//       //a.download = "employees.json";
//       a.click();
//     });
//   });
// }

function downloadExampleData(targetlink) {
  const link = document.createElement("a");
  link.href = "/sample.zip"; // public/sample.zip
  link.download = "sample.zip"; // 다운로드될 파일명
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


//function DCMFileDropzone() {
class DCMFileDropzone extends React.Component {
  downloadLink = Config.sample.dcmlink;
  dropzoneElement = null;

  // const onDrop = useCallback(acceptedFiles => {
  //   const firstfile = [acceptedFiles[0]];
  //   // Do something with the files
  //   Provider.DICOMFileProvider(firstfile);
  // }, []);

  // const { getRootProps, getInputProps } = useDropzone({
  //   onDrop,
  //   noClick: true
  // });

  // const hoverDragDropzone = event => {
  //   dropzoneElement.classList.add("drop-active");
  // };

  // const leaveDragDropzone = event => {
  //   dropzoneElement.classList.remove("drop-active");
  // };

  componentDidMount() {
    //this.dropzoneElement.addEventListener("click", this.handleClick);
  }

  componentWillUnmount() {
    //this.dropzoneElement.removeEventListener("click", this.handleClick);
  }

  handleClick(event) {
    //downloadExampleData(this.downloadLink);
  }
  handleSampleDownloaderClick(event) {
    ReactGA.event({
      category: "Sample file",
      action: "Download sample file",
    });
  }
  render() {
    return (
<React.Fragment>
  <div
    className="dicom-dropzone item-panel"
    ref={(r) => (this.dropzoneElement = r)}
    onClick={this.handleSampleDownloaderClick}
    role="button"
    tabIndex="0"
    onKeyPress={() => downloadExampleData(this.downloadLink)}
  >
    <div className="detail-guide-text text-center item-panel">
      <span className="main-text">
        {"Please put the L3 area DICOM File"}
      </span>
      <span
        className="sub-text color-blue"
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={(e) => {
          e.stopPropagation();
          downloadExampleData(this.downloadLink);
        }}
      >
        {"Click here"}
      </span>
      <span className="sub-text">{" to Download Sample Image"}</span>
    </div>
  </div>
</React.Fragment>
    );
  }
}

export default DCMFileDropzone;
